import type { EventHandler, SyntheticEvent } from 'react';

export default function preventDefault<T extends Element, E extends Event>(
    ...handlers: (undefined | EventHandler<SyntheticEvent<T, E>>)[]
): EventHandler<SyntheticEvent<T, E>> {
    return (event: SyntheticEvent<T, E>) => {
        event?.preventDefault();
        handlers.filter(Boolean).map((h) => h(event));
    };
}
